import { Component } from '@angular/core';
import { Toast, ToastPackage, ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

@Component({
  selector: 'sd-toster-body',
  templateUrl: 'body.component.html',
  styleUrls: ['body.component.scss'],
})
export class BodyComponent extends Toast {
  constructor(
    protected toastrService: ToastrService,
    public toastPackage: ToastPackage,
    private router: Router,
  ) {
    super(toastrService, toastPackage);
  }

  // Override to prevent inherited display:none inline style while toast activates
  get displayStyle(): string | undefined {
    return undefined;
  }

  get data(): any {
    return this.toastPackage.config.payload;
  }

  get text(): string {
    return this.data.text;
  }

  get user(): any {
    return this.data.user || {};
  }

  get isUser(): boolean {
    return !!this.data.user;
  }

  get showManageExportsButton(): any {
    return this.data.showManageExportsButton || false;
  }

  get showReloadButton(): any {
    return this.data.showReloadButton || false;
  }

  onManageExportsButtonClick() {
    this.router.navigate(['/export-manager']);
  }

  onReloadButtonClick() {
    console.log(this.router);
  }
}
